module.exports = __webpack_public_path__ + "static/img/real-links-grey.c66d633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/real-links-grey.svg
// module id = LU1u
// module chunks = 0 115